const awsmobile = {
  "aws_appsync_region": "ap-southeast-2",
  "aws_appsync_authenticationType": "API_KEY",
  "aws_appsync_graphqlEndpoint": "https://ndervbtlmzakdpnnygt3a4dy3a.appsync-api.ap-southeast-2.amazonaws.com/graphql",
  "aws_appsync_apiKey": "da2-lh6n36ce2vasljtvp3wfkpa7xi"
};

export default awsmobile;
